import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';

import {
    REQUEST_PAYMENTTERMS,
    FETCH_PAYMENTTERMS_SUCCESS,
    FETCH_PAYMENTTERMS_FAILURE,
    SELECT_PAYMENTTERM,
    RESET_CURRENT_PAYMENTTERM,
    RESET_CREATE_PAYMENT_TERM,
    RESET_EDIT_PAYMENT_TERM,
    REQUEST_CREATING_PAYMENT_TERM,
    CREATE_PAYMENT_TERM_SUCCESS,
    CREATE_PAYMENT_TERM_FAILURE,
    REQUEST_EDITING_PAYMENT_TERM,
    EDIT_PAYMENT_TERM_SUCCESS,
    EDIT_PAYMENT_TERM_FAILURE
} from './type'

import {
    PAYMENT_URL
} from './url'

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url' 

export function fetchPaymentTerms() {
    return dispatch => {
        dispatch(requestPaymentTerms());
        return axios.get(PAYMENT_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchPaymentTermsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchPaymentTermsFailure(err));                     
              }
            });
    }
}

export function requestPaymentTerms() {
    return {
        type: REQUEST_PAYMENTTERMS,
    };
}

export function fetchPaymentTermsSuccess(paymentTerms) {
    return {
        type: FETCH_PAYMENTTERMS_SUCCESS,
        payload: paymentTerms
    };
}

export function fetchPaymentTermsFailure(error) {
    return {
        type: FETCH_PAYMENTTERMS_FAILURE,
        payload: error
    };
}

export function selectPaymentTerm(paymentTerm) {
    return {
        type: SELECT_PAYMENTTERM,
        payload: paymentTerm
    };
}

export function resetCurrentPaymentTerm() {
    return {
        type: RESET_CURRENT_PAYMENTTERM
    }
}

export function resetCreatePaymentTerm() {
  return {
    type: RESET_CREATE_PAYMENT_TERM,
  }
}

export function resetEditPaymentTerm() {
  return {
    type: RESET_EDIT_PAYMENT_TERM,
  }
}

// Actions to deal with the promise of posting function.

export function createPaymentTerm({ Name, Description, TermDays, Termtype }) {
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PAYMENT_TERM });
        axios.post(PAYMENT_URL,
            { Name, Description, TermDays, Termtype },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createPaymentTermSuccess());
              browserHistory.push('/paymentTerms'); // If created succesfully, refresh the paymentTerm page.
            }, err => {
              const data = err.data;
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createPaymentTermFailure(err));                     
              }
              throw new SubmissionError(data);
            });

    }
}

// export function requestCreatingPaymentTerm() {
//     return {
//         type: REQUEST_CREATING_PAYMENT_TERM
//     }
// }

export function createPaymentTermSuccess() {
    return {
        type: CREATE_PAYMENT_TERM_SUCCESS
    }
}

export function createPaymentTermFailure(error) {
    return {
        type: CREATE_PAYMENT_TERM_FAILURE,
        payload: error
    }
}

export function editPaymentTerm({ PaymentTerm_id, Name, Description, TermDays, Termtype }) {
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_PAYMENT_TERM });
        axios.put((PAYMENT_URL + PaymentTerm_id),
            { Name, Description, TermDays, Termtype },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editPaymentTermSuccess());
              browserHistory.push('/paymentTerms'); // If editd succesfully, refresh the paymentTerm page.
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editPaymentTermFailure(err));                     
              }
            });
    }
}

// export function requestCreatingPaymentTerm() {
//     return {
//         type: REQUEST_EDITING_PAYMENT_TERM
//     }
// }

export function editPaymentTermSuccess() {
    return {
        type: EDIT_PAYMENT_TERM_SUCCESS
    }
}

export function editPaymentTermFailure(error) {
    return {
        type: EDIT_PAYMENT_TERM_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/paymentTerms_actions.js